export const model = {
  id: null,
  name: '',  
  branch_id: null,
  parent_department_id: null,  
  graphic_ids: [],  
  created_at: '',
  updated_at: '',
};
